module.exports = __webpack_public_path__ + "img/selected3-min.c14a4aac.png";